import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var SadTear = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 512 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M169.6 291.3c3.2-4.4 9.6-4.4 12.8 0 13.2 17.3 40.7 57.7 40.7 77.7 0 26-20.6 47-48 47-25.6 0-48-21-48-47 0-20 29.5-60.4 42.5-77.7zM368 346.8c9.9 8.8 10.7 24 1.9 33.9-8.9 9.9-24 10.7-34.8 1.9-20.4-19.1-48.4-30.6-79.1-30.6-13.3 0-24-10.7-24-24s10.7-24 24-24c43 0 82.3 16.2 112 42.8zM335.6 176c17.7 0 32 14.3 32 32s-14.3 32-32 32c-18.5 0-32-14.3-32-32s13.5-32 32-32zm-160 64c-18.5 0-32-14.3-32-32s13.5-32 32-32c17.7 0 32 14.3 32 32s-14.3 32-32 32zM256 0c141.4 0 256 114.6 256 256S397.4 512 256 512 0 397.4 0 256 114.6 0 256 0zm-80.1 448c24.6 10.3 51.7 16 80.1 16 114.9 0 208-93.1 208-208S370.9 48 256 48 48 141.1 48 256c0 52.7 19.59 100.8 51.88 137.4 10.52 32 41.02 54.5 76.02 54.6z"
  }));
});
SadTear.displayName = 'SadTear';
export var SadTearDimensions = {
  height: 512,
  width: 512
};